import React, { useEffect, useRef, useState }  from 'react'
import { HttpClient } from '../../commonApis/httpClient';
import Axios from 'axios';
import { useDispatch } from 'react-redux';
import { actorActions } from '../AES_App/reducer/actorSlice';
import { transportTabActions } from '../AES_App/reducer/transportSlice';
import { containerTabActions } from '../AES_App/reducer/containerSlice';
import { initializeHeaderForm, resetForm } from '../AES_App/reducer/headerSlice';
import { itemActions } from '../AES_App/reducer/ItemSlice';
import { initializeValueBuildUp } from '../commonComponents/commonValueBuildUpTab/actions/ValueBuildUp';

export const useGetFormData = (payload,callback) => {
  const [loader, setLoader] = useState(false)
  const [error, setError] = useState(false)
  const isMounted = useRef(false)
  const dispatch=useDispatch()
useEffect(() => {
    const source = Axios.CancelToken.source();
    const getData = async () => {
      setLoader(true)
      setError('')
      
      try {
        const data = {
            eventMessage: payload,
            eventType: `GET_FORM_${payload.countryCode.toUpperCase()}`,
            eventTime: Date.now(),
        };  
        const response = await HttpClient.custom({data, cancelToken:source.token})  
        isMounted.current = true
        const { 
          data: { 
            eventMessage: { 
              parties, 
              headerTab, 
              transportTab, 
              containerTab, 
              invoiceTab, 
              upperHeader={}, 
              childShipments=null 
            } 
          } 
        } = response
        window.shipmentId = payload.shipmentId
         dispatch(initializeHeaderForm({...headerTab,...upperHeader, childShipments:childShipments }))
         dispatch(actorActions.initializeParties(parties))
         dispatch(transportTabActions.updateTransportHeaderInfo(transportTab))
        dispatch(containerTabActions.inititalizeContainerForm(containerTab))
        dispatch(itemActions.initializeItemsForm(invoiceTab))
        dispatch(initializeValueBuildUp(window.shipmentId))
        
        callback && callback(response)
        // dispatch(initializeItemForm(itemTab))
        // dispatch(resetServerErrors())

        sessionStorage.removeItem('toggleInvoices')
        sessionStorage.removeItem('toggleLineItems')

        setLoader(false)
      } catch (e) {
        if (isMounted.current) {
            setLoader(false)
        }
      }
    }
    getData()
    return () => {
      isMounted.current = false
      source.cancel('Operation canceled by the user.');
      // if(payload.countryCode.toUpperCase()!=='NL'){
      //   dispatch(resetForm());
      // }
    };
  }, [payload.shipmentId])

  return {loader,error,isMounted:isMounted.current};
};